import HttpFactory from '@/mixins/http.factory';
export default {
	name:'success',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			message: null,
			redirectToUrl: null
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self = this;
			_self.redirectToUrl = _self.$route.query.redirectToUrl;
			_self.message = _self.$route.query.message || 'Authentication successful! You can now return to Zendesk. Redirecting...';
		},
		goToZendesk() {
			if(this.redirectToUrl) {
				window.location.href =this.redirectToUrl;
			}
		},
		closePopUp() {
			if(window.opener) {
				window.opener.postMessage('closePopup', '*');
				window.close();
			} else {
				window.close();
			}
		}
	},
	components:{}
}

